import zyTrack from './track'

const dyTrackUtil = {
  track(name, params, callback) {
    zyTrack.send({ event: name, content: params, callback })
  },
  getDyTrackModule() {
    const res = {}
    if (location.pathname === '/douyin/watch/hot') {
      res.module1 = '监控台'
      res.module2 = '监控达人'
      res.module3 = '热销商品'
    } else if (location.pathname === '/douyin/watch/overview') {
      res.module1 = '监控台'
      res.module2 = '监控达人'
      res.module2 = '达人概况'
    } else if (location.pathname === '/douyin/watch/live') {
      res.module1 = '监控台'
      res.module2 = '监控达人'
      res.module2 = '带货直播'
    } else if (location.pathname === '/douyin/watch/news') {
      res.module1 = '监控台'
      res.module2 = '监控达人'
      res.module3 = '新品首发'
    } else if (location.pathname === '/douyin/watch/video') {
      res.module1 = '监控台'
      res.module2 = '监控达人'
      res.module3 = '达人作品'
    } else if (location.pathname === '/douyin/watch/shopNews') {
      res.module1 = '监控台'
      res.module2 = '监控小店'
      res.module3 = '竞店新品'
    } else if (location.pathname === '/douyin/watch/shopHot') {
      res.module1 = '监控台'
      res.module2 = '监控小店'
      res.module3 = '竞店热销'
    } else if (location.pathname === '/douyin/lib/goods/all') {
      res.module1 = '抖音商品库'
      res.module2 = '全部'
    } else if (location.pathname === '/douyin/lib/goods/hot') {
      res.module1 = '抖音商品库'
      res.module2 = '热销'
    } else if (location.pathname === '/douyin/lib/goods/recommend') {
      res.module1 = '抖音商品库'
      res.module2 = '推荐'
    } else if (location.pathname === '/douyin/lib/goods/realTime') {
      res.module1 = '抖音商品库'
      res.module2 = '实时'
    } else if (location.pathname === '/douyin/lib/video') {
      res.module1 = '作品库'
      res.module2 = document.querySelector('.dy-lib-header>.dy-lib-tab-wrap>.dy-lib-tab.active')?.innerText
    } else if (location.pathname === '/douyin/lib/shop') {
      res.module1 = '小店库'
    } else if (location.pathname.indexOf('/douyin/rank') !== -1) {
      res.module1 = '排行榜'
      if (location.pathname === '/douyin/rank/goods') {
        res.module2 = '商品榜'
      } else if (location.pathname === '/douyin/rank/shop') {
        res.module2 = '店铺榜'
      } else if (location.pathname === '/douyin/rank/host') {
        res.module2 = '达人榜'
      } else if (location.pathname === '/douyin/rank/live') {
        res.module2 = '直播榜'
      } else if (location.pathname === '/douyin/rank/video') {
        res.module2 = '作品榜'
      } else if (location.pathname === '/douyin/rank/topic') {
        res.module2 = '话题榜'
      } else if (location.pathname === '/douyin/rank/brand') {
        res.module2 = '品牌榜'
      }
      res.module3 = document.querySelector('.rank-status.active')?.innerText
    } else if (location.pathname === '/douyin/industryAnalysis/commodityAnalysis') {
      res.module1 = '大盘分析'
      res.module2 = '商品分析'
      res.module3 = '热销商品'
    } else if (location.pathname === '/douyin/industryAnalysis/commodityLive') {
      res.module1 = '大盘分析'
      res.module2 = '直播带货'
      res.module3 = '热销商品'
    } else if (location.pathname === '/douyin/industryAnalysis/commodityWorks') {
      res.module1 = '大盘分析'
      res.module2 = '作品带货'
    } else if (location.pathname === '/douyin/hostDetail/overview') {
      res.module1 = '达人详情页'
      res.module2 = '达人概括'
      res.module3 = '近30天热销商品'
    } else if (location.pathname === '/douyin/hostDetail/windowGoods') {
      res.module1 = '达人详情页'
      res.module2 = '带货商品'
      res.module3 = document.querySelector('.title-panel>.tabs>.tab-item.active')?.innerText
    } else if (location.pathname === '/douyin/hostDetail/video') {
      res.module1 = '达人详情页'
      res.module2 = '作品列表'
    } else if (location.pathname === '/douyin/brandDetail/goods') {
      res.module1 = '品牌详情页'
      res.module2 = '商品列表'
      res.module3 = document.querySelector('.title-panel>.tabs>.tab-item.active')?.innerText
    } else if (location.pathname === '/douyin/brandDetail/videos') {
      res.module1 = '品牌详情页'
      res.module2 = '合作作品'
    } else if (location.pathname === '/douyin/brandDetail/lives') {
      res.module1 = '品牌详情页'
      res.module2 = '合作直播'
      res.module3 = '合作商品'
    } else if (location.pathname === '/douyin/brandDetail/hosts') {
      res.module1 = '品牌详情页'
      res.module2 = '合作达人'
      res.module3 = document.querySelector('.title-panel>.tabs>.tab-item.active')?.innerText
    } else if (location.pathname === '/douyin/liveDetail') {
      res.module1 = '直播详情页'
      res.module2 = '带货列表'
    } else if (location.pathname === '/douyin/videoDetail') {
      res.module1 = ' 作品详情页'
      res.module2 = '带货列表'
    } else if (location.pathname === '/douyin/shopDetail/overview') {
      res.module1 = '小店详情页'
      res.module2 = '抖店概况'
      res.module3 = '近30天热销商品'
    } else if (location.pathname === '/douyin/shopDetail/allGoods') {
      res.module1 = '小店详情页'
      res.module2 = '商品列表'
      res.module3 = document.querySelector('.title-panel>.tabs>.tab-item.active')?.innerText
    } else if (location.pathname === '/douyin/shopDetail/videos') {
      res.module1 = '小店详情页'
      res.module2 = '合作作品'
    } else if (location.pathname === '/douyin/shopDetail/liveCoop') {
      res.module1 = '小店详情页'
      res.module2 = '合作达人'
      res.module3 = '直播合作达人'
    } else if (location.pathname === '/douyin/shopDetail/videoCoop') {
      res.module1 = '小店详情页'
      res.module2 = '合作达人'
      res.module3 = '作品合作达人'
    } else if (location.pathname === '/douyin/shopDetail/live') {
      res.module1 = '小店详情页'
      res.module2 = '合作直播'
    } else if (location.pathname === '/itemDetail/like/douyin') {
      res.module1 = '淘系商品详情页'
      res.module2 = ' 相似款式'
      res.module3 = '抖音商品'
    } else if (location.pathname.indexOf('/itemDetail/douyin/like') !== -1) {
      res.module1 = '抖音商品详情页'
      res.module2 = ' 相似款式'
      res.module3 = document.querySelector('.title-panel>.tabs>.tab-item.active')?.innerText
    } else if (location.pathname === '/douyin/topicDetail/overview') {
      res.module1 = '话题详情页'
      res.module2 = '话题概览'
      res.module3 = '热销商品'
    } else if (location.pathname === '/douyin/topicDetail/videos') {
      res.module1 = '话题详情页'
      res.module2 = '关联作品'
    } else if (location.pathname === '/douyin/lib/host') {
      res.module1 = '达人库'
    } else if (location.pathname === '/itemDetail/douyin/info') {
      res.module1 = '抖音商品详情页'
      res.module2 = '商品概括'
    } else if (location.pathname === '/itemDetail/douyin/live') {
      res.module1 = '抖音商品详情页'
      res.module2 = '直播分析'
    } else if (location.pathname === '/itemDetail/douyin/video') {
      res.module1 = '抖音商品详情页'
      res.module2 = '作品分析'
    } else if (location.pathname === '/itemDetail/douyin/host') {
      res.module1 = '抖音商品详情页'
      res.module2 = '达人分析'
      res.module3 = document.querySelector('.title-panel>.tabs>.tab-item.active')?.innerText
    } else if (location.pathname === '/itemDetail/dyInfo/video') {
      res.module1 = '淘系商品详情页'
      res.module2 = '抖音动态'
      res.module3 = '作品分析'
    } else if (location.pathname === '/itemDetail/dyInfo/info') {
      res.module1 = '淘系商品详情页'
      res.module2 = '抖音动态'
      res.module3 = '抖音概况'
    } else if (location.pathname === '/itemDetail/dyInfo/host') {
      res.module1 = '淘系商品详情页'
      res.module2 = '抖音动态'
      res.module3 = '达人分析'
    } else if (location.pathname === '/shopDetail/douyin') {
      res.module1 = '淘系店铺详情页'
      res.module2 = '抖音热推'
      res.module3 = document.querySelector('.title-panel>.tabs>.tab-item.active')?.innerText
    } else if (location.pathname === '/home') {
      res.module1 = '知衣首页'
      res.module2 = '最近访问'
      res.module3 = '抖音达人'
    } else if (location.pathname.indexOf('/douyin/search') !== -1) {
      res.module1 = '搜索'
      res.module2 = document.querySelector('.tab.active.active')?.innerText
    } else if (location.pathname === '/douyin/watch/shopOverView') {
      res.module1 = '监控台'
      res.module2 = '竞店概览'
    } else if (location.pathname === '/douyin/hostDetail/dyShop') {
      res.module1 = '达人详情页'
      res.module2 = '合作店铺'
    } else if (location.pathname === '/imageSearch') {
      res.module1 = '智能搜图'
      res.module2 = document.querySelector('.image-search-result>.tabs>.tab.active')?.innerText
      res.module3 = document.querySelector('.image-search-platform-wrapper>.image-search-platform-item.active')?.innerText
    } else if (location.pathname === '/douyin/hostDetail/brand') {
      res.module1 = '达人详情页'
      res.module2 = '达人概览'
      res.module3 = '近30天热销商品'
    }
    return res
  },
  selectedFilter(eventName, params) {
    for (const i in params) {
      if (typeof params[i] === 'number') {
        params[i] = params[i].toString()
      } else if (Array.isArray(params[i])) {
        params[i].forEach((item, index) => {
          if (typeof item === 'number') {
            params[i][index] = item.toString()
          }
        })
      }
    }
    this.track(eventName, {
      ...this.getDyTrackModule(),
      ...params
    })
  }
}
export default dyTrackUtil
